import { reducer as formReducer } from "redux-form";

const initialState = {
  posts: [],
  homePage: {},
  humanlyPage: {},
  humanlyIssues: [],
  peopleCategories: [],
  archivesPage: {},
  aboutPage: { clients: [], press: [], culturePanelHeadshots: [] },
  footer: {},
  loaders: {
    homePage: false,
    posts: false,
    humanlyPage: false,
    humanlyIssues: false,
    aboutPage: false,
    footer: false,
  },
  form: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "LOAD_FOOTER": {
      return {
        ...state,
        footer: deSerializeFooter(action.content),
        loaders: { ...state.loaders, footer: true },
      };
    }
    case "LOAD_HOME_PAGE": {
      return {
        ...state,
        homePage: deSerializeHomePage(action.content),
        loaders: { ...state.loaders, homePage: true },
      };
    }
    case "LOAD_POSTS": {
      return {
        ...state,
        posts: deSerializePost(action.content),
        loaders: { ...state.loaders, posts: true },
      };
    }
    case "LOAD_ABOUT_PAGE": {
      return {
        ...state,
        aboutPage: deSerializeAboutPage(action.content),
        loaders: { ...state.loaders, about: true },
      };
    }
    case "LOAD_ARCHIVES_PAGE": {
      return {
        ...state,
        archivesPage: deSerializeArchivesPage(action.content),
        loaders: { ...state.loaders, archivesPage: true },
      };
    }
    case "LOAD_HUMANLY_PAGE": {
      return {
        ...state,
        humanlyPage: deSerializeHumanlyPage(action.content),
        loaders: { ...state.loaders, humanlyPage: true },
      };
    }
    case "LOAD_PEOPLE_CATEGORIES": {
      return {
        ...state,
        peopleCategories: deSerializePeopleCategories(action.content),
        loaders: { ...state.loaders, peopleCategories: true },
      };
    }
    case "LOAD_HUMANLY_ISSUES": {
      return {
        ...state,
        humanlyIssues: deSerializeHumanlyIssues(action.content),
        loaders: { ...state.loaders, humanlyIssues: true },
      };
    }
    default: {
      return { ...state, form: formReducer(state.form, action) };
    }
  }
};

const deSerializeHomePage = (content) => {
  let page = {};
  const homePage = content.items[0];
  const fields = homePage.fields;

  page.splash = fields.splashImage.fields.file.url;
  page.splashMobile = fields.splashImageMobile.fields.file.url;
  page.splash2 = fields.secondSplashImage.fields.file.url;
  page.splash2Mobile = fields.secondSplashImageMobile.fields.file.url;
  page.humanlyIssues = fields.humanlyIssueLinks.map((l) => {
    return {
      issueNumber: l.fields.issueNumber,
      image: l.fields.coverImage.fields.file.url,
    };
  });
  page.tagline = fields.tagline;
  return page;
};

const mapOrgLink = (o) => {
  return {
    logo: o.fields.logo.fields.file.url,
    link: o.fields.link,
    name: o.fields.name,
  };
};

const deSerializeAboutPage = (content) => {
  const about = content.items[0].fields;

  return {
    ...about,
    splash: about.splashImage.fields.file.url,
    splash2: about.secondSplashImage.fields.file.url,
    clients: about.clients.map(mapOrgLink),
    press: about.press.map(mapOrgLink),
    culturePanelHeadshots: about.culturePanelHeadshots.map((h) => h.fields.file.url),
    bottomSplash: about.bottomSplashImage.fields.file.url,
    teamImage: about.teamImage ? about.teamImage.fields.file.url : null,
  };
};

const deSerializeArchivesPage = (content) => {
  const archivesPage = content.items[0];
  return {
    splash: archivesPage.fields.splashImage.fields.file.url,
    title: archivesPage.fields.title,
    subtitle: archivesPage.fields.subtitle,
  };
};

const deSerializePost = (content) => {
  return content.items.map((i) => {
    return { id: i.sys.id, ...i.fields };
  });
};

const deSerializeHumanlyPage = (content) => {
  let page = {};
  const items = content.items[0];
  page.splash = items.fields.splashImage.fields.file.url;
  page.description = items.fields.description;
  return page;
};

const deSerializeHumanlyIssues = (content) => {
  return content.items.map((i) => {
    return { id: i.sys.id, ...i.fields };
  });
};

const deSerializeFooter = (content) => {
  const item = content.items[0];
  return { ...item.fields };
};

const deSerializePeople = (people) => {
  return people.map((person) => ({
    id: person.sys.id,
    ...person.fields,
    photo: person.fields.photo ? person.fields.photo.fields.file.url : null,
  }));
};

const deSerializePeopleCategories = (content) => {
  return content.items
    .map((item) => {
      return {
        id: item.sys.id,
        ...item.fields,
        people: deSerializePeople(item.fields.people),
      };
    })
    .sort((a, b) => (a.order < b.order ? -1 : 1));
};



// WEBPACK FOOTER //
// ./src/reducer.js